import styled from 'styled-components';

export const StyledSvg = styled.svg`
  flex-shrink: 0;
`;
